// A letter that has gone out must not go out again by a second press. After a send, the same details
// are blocked; changing any detail unblocks it, so a deliberate re-send is still possible
// (triage FE-06-19, FE-06-15).
export function sendFingerprint(details) {
  return JSON.stringify(details);
}

export function alreadySent(sentFingerprint, currentFingerprint) {
  return sentFingerprint !== null && sentFingerprint === currentFingerprint;
}
